import React from 'react';
import DfpAd from '../../../../Areas/MyTradera/static/script/app/components/ads/dfp-ad.jsx';

class DfpAdInitDataDecorator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageTargeting: props.initData.gptData.customTargetingParameters,
            adUnitPath: props.initData.gptData.adUnitPath
        };
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.initData &&
            nextProps.initData.gptData &&
            nextProps.initData.gptData.customTargetingParameters
        ) {
            this.setState({
                pageTargeting:
                    nextProps.initData.gptData.customTargetingParameters,
                adUnitPath: nextProps.initData.gptData.adUnitPath
            });
        }
    }

    render() {
        return <DfpAd {...this.state} {...this.props} />;
    }
}
export default DfpAdInitDataDecorator;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/ads/dfp-ad-init-data-decorator.js